const DAY_IN_MS = 24 * 60 * 60 * 1000;
const HOUR_IN_MS = 60 * 60 * 1000;
const MINUTE_IN_MS = 60 * 1000;

/**
 * Format a future ISO timestamp into a relative countdown + friendly absolute time.
 *
 * Examples:
 *  - "3 days 4 hours (Nov 18, 2:00 PM)"
 *  - "less than 1 hour (Nov 11, 5:05 PM)"
 */
export function formatResetCountdown(isoDate?: string | null): string | null {
  if (!isoDate) {
    return null;
  }

  const resetDate = new Date(isoDate);
  if (Number.isNaN(resetDate.getTime())) {
    return null;
  }

  const diffMs = resetDate.getTime() - Date.now();

  if (diffMs <= 0) {
    return `soon (${resetDate.toLocaleString()})`;
  }

  const days = Math.floor(diffMs / DAY_IN_MS);
  const hours = Math.floor((diffMs % DAY_IN_MS) / HOUR_IN_MS);
  const minutes = Math.floor((diffMs % HOUR_IN_MS) / MINUTE_IN_MS);

  const parts: string[] = [];

  if (days > 0) {
    parts.push(`${days} day${days === 1 ? '' : 's'}`);
  }

  if (hours > 0) {
    parts.push(`${hours} hour${hours === 1 ? '' : 's'}`);
  }

  if (parts.length === 0 && minutes > 0) {
    parts.push(`${minutes} min${minutes === 1 ? '' : 's'}`);
  }

  const relative = parts.slice(0, 2).join(' ') || 'less than 1 hour';

  return `${relative} (${resetDate.toLocaleString()})`;
}
